export const FORM_VALIDATION = {
  businessName: {
    required: "Business or Brand Name is required",
  },
  location: {
    required: "Location is required",
    minLength: {
      value: 3,
      message: "Location must be at least 3 characters long",
    },
    validate: {
      validLocation: (value: string) => {
        if (!value || value.trim().length === 0) {
          return "Location is required";
        }
        if (value.length < 3) {
          return "Location must be at least 3 characters long";
        }
        return true;
      },
    },
  },
  pincode: {
    required: "Pincode is required",
    pattern: { 
      value: /^[0-9]{6}$/, 
      message: "Invalid Pincode" 
    },
  },
  fssaiNumber: {
    pattern: {
      value: /^\d{14}$/,
      message: "FSSAI number must be 14 digits",
    },
  },
  gstNumber: {
    pattern: {
      value: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/,
      message: "Invalid GST number",
    },
  },
} as const;

export const FORM_FIELDS = {
  businessName: {
    label: "Business or Brand Name",
    placeholder: "Enter business name ",
  },
  pincode: {
    label: "Pincode",
    placeholder: "Enter pincode ",
  },
  fssaiNumber: {
    label: "FSSAI Number",
    placeholder: "Enter FSSAI number",
  },
  gstNumber: {
    label: "GST Number",
    placeholder: "Enter GST number ",
  },
} as const; 